import React, { Fragment, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Layout from '../../components/Layout/Layout';
import Hero4 from '../../components/hero4/hero4';
import About from '../../components/Cyber-Security-Components/about/about';
import HomePortfolioSlider from '../../components/HomePortfolioSlider';
import HomeServices from '../../components/HomeServices';
import HomeProducts from '../../components/HomeProducts';
import Seo from '../../components/Seo';
import NotFoundPage from './NotFoundPage';

const HomePage = () => {
    const { t, i18n } = useTranslation();
    const { lang } = useParams();

    // Set language based on URL parameter - must be before any early returns (Rules of Hooks)
    useEffect(() => {
        if (lang && (lang === 'en' || lang === 'ka')) {
            i18n.changeLanguage(lang);
        }
    }, [lang, i18n]);

    // If a single-segment path is not 'en' or 'ka', it's an invalid URL -> show 404 page
    if (lang && lang !== 'en' && lang !== 'ka') {
        return <NotFoundPage />;
    }

    return (
        <Fragment>
            <Seo 
                title={t('seo.home.title')}
                description={t('seo.home.description')}
                keywords={t('seo.home.keywords')}
                url={`/${lang}`}
            />
            <Layout>
                <main className="page_content overflow-hidden">
                    <Hero4 />
                    <HomePortfolioSlider />
                    <HomeServices />
                    <HomeProducts />
                    <About />
                </main>
            </Layout>
        </Fragment>
    );
};

export default HomePage;